module.exports = __webpack_public_path__ + "media/apps/mitch-android-2-e8287b3d.png";